export class AppAccordion extends HTMLElement {
  private items: { order: number; question: string; answer: string }[] = [];

  constructor() {
    super();
  }

  connectedCallback() {
    this.items = this.parseItems();
    this.render();
  }

  static get observedAttributes() {
    return ["items"];
  }

  parseItems(): { order: number; question: string; answer: string }[] {
    const raw = this.getAttribute("items");
    if (raw) {
      try {
        const parsed = JSON.parse(raw);
        return parsed.map((item: any) => ({
          order: item.Order ?? item.order ?? 0,
          question: item.Question ?? item.question ?? "",
          answer: item.Answer ?? item.answer ?? "",
        }));
      } catch {
        // ignore
      }
    }
    // Fallback: read from child data attributes
    const children = Array.from(this.children);
    return children
      .filter((el) => el.hasAttribute("data-question"))
      .map((el) => ({
        order: parseInt(el.getAttribute("data-order") || "0", 10),
        question: el.getAttribute("data-question") || "",
        answer: el.getAttribute("data-answer") || "",
      }));
  }

  render() {
    // Clear existing
    this.innerHTML = "";

    const container = document.createElement("div");
    container.className = "w-full flex flex-col gap-4 font-normal";

    for (const item of this.items) {
      const id = `faq-${item.order}`;

      // Wrapper
      const wrapper = document.createElement("div");
      wrapper.className = "w-full";

      // Button
      const btn = document.createElement("button");
      btn.className =
        "w-full bg-green-light rounded-lg px-6 md:px-8 py-2 flex items-center gap-4 md:gap-6 text-left hover:bg-green-light";
      btn.setAttribute("data-target", id);

      // Number
      const numSpan = document.createElement("span");
      numSpan.className = "text-gold text-2xl md:text-4xl font-bold shrink-0";
      numSpan.textContent = String(item.order);

      // Question
      const qSpan = document.createElement("span");
      qSpan.className =
        "text-cream text-base md:text-xl font-medium flex-1 leading-tight";
      qSpan.textContent = item.question;

      // Arrow
      const arrowSvg = document.createElementNS(
        "http://www.w3.org/2000/svg",
        "svg",
      );
      arrowSvg.setAttribute(
        "class",
        "faq-arrow w-6 h-6 text-gold shrink-0 transition-transform duration-300",
      );
      arrowSvg.setAttribute("fill", "currentColor");
      arrowSvg.setAttribute("viewBox", "0 0 20 20");
      arrowSvg.innerHTML =
        '<polygon points="4,7 16,7 10,14" />';

      btn.append(numSpan, qSpan, arrowSvg);

      // Answer
      const answerDiv = document.createElement("div");
      answerDiv.id = id;
      answerDiv.className =
        "faq-answer hidden bg-green rounded-b-lg px-6 md:px-8 py-6";
      const p = document.createElement("p");
      p.className = "text-cream-light text-base md:text-lg leading-relaxed";
      // Convertir saltos de línea en <br> para permitir formato multilínea
      p.innerHTML = item.answer.replace(/\n/g, "<br>");
      answerDiv.appendChild(p);

      wrapper.append(btn, answerDiv);
      container.appendChild(wrapper);
    }

    this.appendChild(container);
    this.bindEvents();
  }

  bindEvents() {
    const buttons = this.querySelectorAll<HTMLButtonElement>(
      "button[data-target]",
    );
    buttons.forEach((btn) => {
      btn.addEventListener("click", () => {
        const targetId = btn.getAttribute("data-target")!;
        const answer = document.getElementById(targetId);
        const arrow = btn.querySelector(".faq-arrow") as SVGElement | null;
        const allAnswers = this.querySelectorAll<HTMLElement>(".faq-answer");
        const allArrows = this.querySelectorAll<SVGElement>(".faq-arrow");
        const allButtons = this.querySelectorAll<HTMLButtonElement>(
          "button[data-target]",
        );

        const isOpen = answer && !answer.classList.contains("hidden");

        allAnswers.forEach((el) => el.classList.add("hidden"));
        allArrows.forEach((el) => (el.style.transform = "rotate(0deg)"));
        allButtons.forEach((b) => {
          b.classList.remove("rounded-b-none");
          b.classList.add("rounded-[6rem]");
        });

        if (answer && !isOpen) {
          answer.classList.remove("hidden");
          if (arrow) arrow.style.transform = "rotate(180deg)";
          btn.classList.remove("rounded-[6rem]");
          btn.classList.add("rounded-b-none");
        }
      });
    });
  }
}

if (typeof window !== "undefined") {
  customElements.define("app-accordion", AppAccordion);
}
